export default __webpack_public_path__ + "static/media/GrassNew.704e0676.png";